<template>
  <div class="home">
    <div> <img src="@/assets/banner.png" /></div>
    <el-row style="margin-top:-80px">
      <el-col class="btn" :span="18" :offset="3">
        <img src="@/assets/btn1.png"  @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1183065125980995584')"/>
      </el-col>
       <el-col class="btn panel" :span="18" :offset="3" :class="{ expanded: isExpanded }" >
        <img src="@/assets/btn2.png" style="display: block;" @click="togglePanel"/>
        <div class="panel-content" ref="contentRef" :style="{ maxHeight: isExpanded ? `${contentHeight}px` : '0px' }">
          <div class="item-row" >
            <div class="item"  @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1188889359961554944')">
              <img src="@/assets/shangchen.png" />
              <div class="item-name">上城</div>
            </div> 
            <div class="item" @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1180885783389667328')">
              <img src="@/assets/gongshu.png" />
              <div class="item-name">拱墅</div>
            </div>
            <div class="item">
              <img src="@/assets/xihu.png" @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1176571498245128192')"/>
              <div class="item-name">西湖</div>
            </div>
            </div>
             <div class="item-row" >
               <div class="item">
              <img src="@/assets/bingjiang.png" @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1188539681784987648')" />
              <div class="item-name">滨江</div>
            </div>
             <div class="item">
              <img src="@/assets/qiantang.png" @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1196000095867240448')" />
              <div class="item-name">钱塘</div>
            </div>
            <div class="item">
              <img src="@/assets/xiaoshan.png" @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1175473004235194368')" />
              <div class="item-name">萧山</div>
            </div>
            </div>
             <div class="item-row" style="justify-content: space-around;" >
           <div class="item" @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1189292268100517888')">
              <img src="@/assets/tonglu.png" />
              <div class="item-name">桐庐</div>
            </div>
            <div class="item"  @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1192927068497641472')">
              <img src="@/assets/jiande.png" />
              <div class="item-name">建德</div>
            </div>
            
          </div>
          <!-- <div class="item-row" >
            <div class="item">
              <img src="@/assets/bingjiang.png" />
              <div class="item-name">滨江</div>
            </div>
            <div class="item">
              <img src="@/assets/xiaoshan.png" />
              <div class="item-name">萧山</div>
            </div>
            <div class="item">
              <img src="@/assets/yuhang.png" />
              <div class="item-name">余杭</div>
            </div>
          </div>
          <div class="item-row" >
            <div class="item">
              <img src="@/assets/lingpin.png" />
              <div class="item-name">临平</div>
            </div>
            <div class="item">
              <img src="@/assets/qiantang.png" />
              <div class="item-name">钱塘</div>
            </div>
            <div class="item">
              <img src="@/assets/fuyang.png" />
              <div class="item-name">富阳</div>
            </div>
          </div>
          <div class="item-row" >
            <div class="item">
              <img src="@/assets/linan.png" />
              <div class="item-name">临安</div>
            </div>
            <div class="item">
              <img src="@/assets/tonglu.png" />
              <div class="item-name">桐庐</div>
            </div>
            <div class="item">
              <img src="@/assets/cunan.png" />
              <div class="item-name">淳安</div>
            </div>
            <div class="item">
              <img src="@/assets/jiande.png" />
              <div class="item-name">建德</div>
            </div>
          </div> -->
        </div>
      </el-col>
       <el-col class="btn" :span="18" :offset="3" >
        <img src="@/assets/btn3.png"  @click="goto('https://apiv4.cst123.cn/cst/theme/shareDetail.html?id=1188147823447638016')"/>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import { ref, nextTick } from 'vue';
const isExpanded = ref(false);
const contentRef = ref(null); // 绑定内容容器 ref
const contentHeight = ref(0); // 存储内容实际高度

const togglePanel = async () => {
  isExpanded.value = !isExpanded.value;
  
  // 等待 DOM 更新后计算高度
  await nextTick();
  if (isExpanded.value) {
    // 展开时：获取内容容器的实际滚动高度
    contentHeight.value = contentRef.value.scrollHeight;
  } else {
    // 收缩时：先设为当前高度，再过渡到 0（保证动画）
    contentHeight.value = contentRef.value.scrollHeight;
    // 延迟触发收缩（让 CSS 过渡生效）
    setTimeout(() => {
      contentHeight.value = 0;
    }, 0);
  }
};
const goto = function(url){
  if (url){
    window.location = url
  }
}
   function share() {
            let url = window.location.href
            let ws = new WebSocket('wss://apiv4.cst123.cn/hzaccounts/ws/token')
            ws.onerror = (e) => {
                console.log(e)
            }
            ws.onopen = () => {
                console.log('open')
                ws.send(url)
            }
            ws.onmessage = (e) => {
                console.log("share", e)
                let config = JSON.parse(e.data)
                config.jsApiList = ["updateAppMessageShareData", "updateTimelineShareData", 'onMenuShareTimeline', 'onMenuShareAppMessage']
                config.openTagList = ["wx-open-launch-app"]
                config.debug = false
                wx.config(config)
                wx.ready(() => {
                    wx.updateTimelineShareData({
                        title: document.title,
                        link: location.href,
                        imgUrl: 'http://cst-media.oss-cn-hangzhou.aliyuncs.com/guodi/mSG4w8mCPE.jpg',
                        success() { }
                    });
                    wx.updateAppMessageShareData({
                        title: document.title,
                        desc: '',
                        link: location.href,
                        imgUrl: 'http://cst-media.oss-cn-hangzhou.aliyuncs.com/guodi/mSG4w8mCPE.jpg',
                        success() { }
                    });
                })
                wx.error(e => {
                    console.log("微信分享设置失败")
                })
            }
            ws.onclose = () => {
                console.log('close')
            }
        }
        share()
</script>
<style scope>
  .home{min-height: 100vh;background-color:#f8ebdf ;}
  img{width:100%;height:auto;display:block}
  .btn{margin-bottom:20px}
  .panel-content{max-height: 0; overflow: hidden;width:90%;margin-left:5%;background-color: #fff1e3;border-radius: 0 0 10px 10px; border:0;  transition: 
    max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);border:1px solid #f46035;border-top:0px;}
  .item-row{display: flex;justify-content: space-between;margin-top:-1px}
  .item {width:25%;padding:10px}
  .item-name{text-align: center;font-size:16px;margin-top:5px}
  .expanded   .panel-content{}
</style>